import React from 'react';
import Loading from '../components/Loading';
import RequestCard from '../components/cards/RequestCard';
import { useRequestsWithoutNotificationCount } from '../context/RequestsContext';
import { useVenueFeedback } from '../context/VenueFeedbackContext';
import { useUserPermissions } from '../hooks/useUserData';
import '../styles/OrdersPage.css';

const RequestsPage = () => {
  const { requests, loading, updateRequestStatus } = useRequestsWithoutNotificationCount();
  const { pushFeedback } = useVenueFeedback();
  const userPermissions = useUserPermissions();

  if (loading) {
    return <Loading />;
  }

  const canUpdateRequests = userPermissions.includes('edit_requests');
  const pendingRequests = requests.filter((request) => request.status === 'pending');
  const completedRequests = requests.filter((request) => request.status === 'completed');

  const handleRequestUpdate = async (requestId, newStatus) => {
    try {
      await updateRequestStatus(requestId, newStatus);
      pushFeedback({
        type: 'success',
        title: newStatus === 'completed' ? 'Talep tamamlandı' : 'Talep yeniden açıldı',
        message:
          newStatus === 'completed'
            ? 'Talep listesi güncellendi.'
            : 'Talep tekrar bekleyen talepler listesine taşındı.',
      });
    } catch (error) {
      pushFeedback({
        type: 'error',
        title: 'Talep güncellenemedi',
        message: error?.message || 'Talep durumu güncellenirken bir sorun oluştu.',
      });
    }
  };

  return (
    <div className="venue-page">
      <div className="venue-requests-layout">
        <section className="venue-surface-card venue-surface-card--padded venue-requests-section venue-requests-section--pending">
          <div className="venue-section-header">
            <h2 className="venue-section-title">Bekleyen Talepler</h2>
            <span className="venue-chip venue-chip--pending">{pendingRequests.length}</span>
          </div>
          {pendingRequests.length === 0 ? (
            <div className="venue-empty-state">
              <p className="venue-empty-state__title">Bekleyen talep yok</p>
              <p className="venue-empty-state__text">Yeni bir yardım veya hesap isteği geldiğinde burada görünecek.</p>
            </div>
          ) : (
            <div className="venue-requests-list">
              {pendingRequests.map((request) => (
                <RequestCard
                  key={request.id}
                  request={request}
                  onUpdate={handleRequestUpdate}
                  dimmed={false}
                  canUpdate={canUpdateRequests}
                />
              ))}
            </div>
          )}
        </section>

        <section className="venue-surface-card venue-surface-card--padded venue-requests-section venue-requests-section--completed">
          <div className="venue-section-header">
            <h2 className="venue-section-title">Tamamlanan Talepler</h2>
            <span className="venue-chip venue-chip--completed">{completedRequests.length}</span>
          </div>
          {completedRequests.length === 0 ? (
            <div className="venue-empty-state">
              <p className="venue-empty-state__title">Tamamlanan talep yok</p>
              <p className="venue-empty-state__text">Kapatılan talepler bu bölümde izlenir.</p>
            </div>
          ) : (
            <div className="venue-requests-list">
              {completedRequests.map((request) => (
                <RequestCard
                  key={request.id}
                  request={request}
                  onUpdate={handleRequestUpdate}
                  dimmed={true}
                  canUpdate={canUpdateRequests}
                />
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default RequestsPage;
